import { Button } from 'antd';

import { useModel } from '@/hooks/useModel';
import { useTranslation } from '@/i18n/client';

export default function LogOut(): JSX.Element {
  const { logout } = useModel('auth-model', (model) => ({
    logout: model.logout
  }));
  const { t } = useTranslation();

  return (
    <Button onClick={() => logout()} type="primary">
      {t('menu.logout')}
    </Button>
  );
}
